class BasicInformation {

    constructor() {
        this.init();
    }

    init(){

        this.email = 'inquiries@blvd.ltd';

        this.phoneLifecell = '+38 (093) 075 13 57';
        this.phoneKyivstar = '+38 (098) 075 13 57';

        this.socialInstagram = 'https://instagram.com/';
        this.socialFacebook = 'https://facebook.com/';
        this.socialLinkedIn = 'https://linkedin.com/';
        this.socialTelegram= 'https://t.me/';

        this.appName = 'Blvd';
        this.iosQrCode = '/assets/qr-code/NAME.png';
        this.iosApp = 'https://apps.apple.com/us/app/';
        this.androidQrCode = '/assets/qr-code/me.png';
        this.androidApp = 'https://play.google.com/store/apps/details?id=';

        this.address = '';

        this.clientURL = 'https://my.bulvar.uk';
    }
}

export default new BasicInformation();